var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.contact)?_c('div',[_c('div',{staticStyle:{}},[(_vm.contact.email)?_c('a',{staticClass:"text-primary",attrs:{"href":'mailto:' +
          _vm.contact.email +
          '?subject=' +
          _vm.subject +
          '&body=' +
          _vm.emailBody}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"envelope-fill"}})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.contact.firstName)+" "+_vm._s(_vm.contact.lastName)+" "),(_vm.contact.phone)?_c('a',{staticClass:"text-primary",attrs:{"href":'tel:' + _vm.contact.phone}},[_c('b-icon',{staticClass:"ml-2",attrs:{"icon":"telephone-fill"}})],1):_vm._e()]),_c('div',[_vm._v(" "+_vm._s(_vm.contact.phone)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }